var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.carousels.bottomOfPage),function(carousel){return _c('lazy-product-carousel',{key:carousel.carouselUrl,staticClass:"pdp-lazy-product-carousel",attrs:{"carousel":carousel}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }